export const API_URL = "https://api-medclick.easymed.fun/api/";
//export const API_URL = "http://localhost:8000/api/";
//export const API_URL = "http://192.168.1.22:8000/api/";

export const LOGGIN_API = API_URL + "login_check";

export const ADMIN_API = API_URL + "admin";
